import pkg from '../../package.json'

export const LANG_COOKIE_NAME = `${pkg.soveluss.uuid}-lang`